import React, { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { fetchSettings } from "../lib/api";
import { initPixels, trackPageView } from "../lib/tracking";

export default function PixelTracker() {
  const location = useLocation();
  const ready = useRef(false);

  useEffect(() => {
    fetchSettings()
      .then((s) => {
        initPixels(s);
        ready.current = true;
      })
      .catch(() => {});
  }, []);

  useEffect(() => {
    if (ready.current) trackPageView();
  }, [location.pathname]);

  return null;
}
